import React from 'react';

const AccordionContext = React.createContext({});

export { AccordionContext };
